import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  constructor() { }

  getIcon(key) {
    const icons = {
      // Connect Series
      LW260: 'icon-lw260_socket_1gang',
      LW270: 'icon-lw270_socket_2gang',
      LW300: 'icon-lw321-lw301_plug_in_dimmer',
      LW320: 'icon-lw321-lw301_plug_in_dimmer',
      LW380: 'icon-lw321-lw301_plug_in_dimmer',
      LW400: 'icon-lw400-lw450_dimmer_1gang',
      LW420: 'icon-lw420_lw452-lw455_dimmer_2gang',
      LW430: 'icon-lw430_dimmer_3gang',
      LW440: 'icon-lw440_dimmer_4gang',
      LW600: 'icon-lw600_energy_monitor',
      LW601: 'icon-lw600_energy_monitor',
      LW821: 'icon-lw821_in_line_relay',
      LW825: 'icon-lw825_in_line_relay',
      LW830: 'icon-lw830-831_in_line_relay',
      LW831: 'icon-lw830-831_in_line_relay',
      LW560: 'icon-lw822',
      LW822: 'icon-lw822',
      LW920: 'icon-lw920-lw934_electric-boiler_switch',
      LW921: 'icon-lw921_thermostat',
      LW921E: 'icon-lw921_thermostat',
      LW922: 'icon-lw922_trv',
      LW928: 'icon-lw100_lw104_remote',
      LW929: 'icon-homeaway',
      LW931: 'icon-lw931_mag_trigger',
      LW934: 'icon-lw920-lw934_electric-boiler_switch',
  
      // Hue
      HUE_SULTAN_BULB: 'icon-philips-hue-lamp-lamp-sultan',

      // Smart Series
      L2: 'icon-l2_link_plus',
      LINK2: 'icon-l2_link_plus',
      linkplus: 'icon-l2_link_plus',
      L21: 'icon-l21_dimmer_1gang',
      L21EU: 'icon-l21_dimmer_1gang',
      L21MK2: 'icon-l21_dimmer_1gang',
      L22: 'icon-l22_dimmer_2gang',
      L22MK3: 'icon-l22_dimmer_2gang',
      L22EU: 'icon-lw420_lw452-lw455_dimmer_2gang_eu',
      L22MK2: 'icon-l22_dimmer_2gang',
      L23: 'icon-l23_dimmer_3gang',
      L23EU: 'icon-l23_dimmer_3gang',
      L24: 'icon-l24_dimmer_4gang',
      L24EU: 'icon-l24_dimmer_4gang',
      L40: 'icon-lw321-lw301_plug_in_dimmer',
      L40TE: 'icon-lw321-lw301_plug_in_dimmer',
      L40TF: 'icon-lw321-lw301_plug_in_dimmer',
      L40TG: 'icon-lw321-lw301_plug_in_dimmer',
      L41: 'icon-l41_socket_1gang',
      L41EU: 'icon-l41_socket_1gang',
      L41TF: 'icon-l41_socket_1gang',
      L41TE: 'icon-l41_socket_1gang',
      L41TG: 'icon-l41_socket_1gang',
      L42: 'icon-l42_socket_2gang',
      L40MK2: 'icon-lp40',
      L42MK2: 'icon-l42_socket_2gang',
      L42MK3: 'icon-l42_socket_2gang',
      L24MK3: 'icon-l24_dimmer_4gang',
      L42EU: 'icon-l42_socket_2gang',
      L51: 'icon-l21_dimmer_1gang',
      L52: 'icon-l22_dimmer_2gang',
      L53: 'icon-lw430_dimmer_3gang_eu',
      L54: 'icon-lw440_dimmer_4gang_eu',
      L70: 'icon-pir',
      L70MK2: 'icon-pir',
      // L71 currently has no icon
      L71: 'icon-lw931_mag_trigger',
      L81: 'icon-lw821_in_line_relay',
      L82: 'icon-lw821_in_line_relay',
      L83: 'icon-lw825_in_line_relay',
      L92: 'icon-lw920-lw934_electric-boiler_switch',
      L92R: 'icon-lw920-lw934_electric-boiler_switch',

      // Features and App
      locked: 'icon-locked_thick',
      unlocked: 'icon-unlocked_thick',
      protection: 'icon-locked_thick',
      inuse: 'icon-plugged',
      notinuse: 'icon-unplugged',
      batteryLevel: 'icon-batt_3',
      battery: 'icon-batt_3',
      signal0: 'icon-signal_0',
      signal1: 'icon-signal_1',
      signal2: 'icon-signal_2',
      favourites: 'icon-favourites',
      rooms: 'icon-rooms',
      automation: 'icon-automation',
      settings: 'icon-settings',
      home: 'icon-home',
      homeAway: 'icon-homeaway',
      homeKit: 'icon-apple_logo',
      user: 'icon-user',
      power: 'icon-power',
      lock: 'icon-locked_thick',
      unlock: 'icon-unlocked_thick',
      check: 'icon-tick',
      eye: 'icon-eye',
      eyeOff: 'icon-eye_strikethrough',
      energy: 'icon-watt',
      duskTime: 'icon-sunset',
      dawnTime: 'icon-sunrise',
      time: 'icon-timer',
      valveLevel: 'icon-valve',
      heatState: 'icon-power',
      threeWayRelay: 'icon-power',
      switch: 'icon-power',
      targetTemperature: 'icon-heating',
      temperature: 'icon-heating',
      buttonPress: 'icon-sensors',
      windowPosition: 'icon-sensors',
      dimLevel: 'icon-bulb',
      lighting: 'icon-bulb',
      rgbColor: 'icon-rgb-color',
      outletInUse: 'icon-plugged',
      outletNotUse: 'icon-unplugged',
      IOSAPP: 'icon-mobile',
      ANDROIDAPP: 'icon-mobile',
      withinRadius: 'icon-map-o',
      valveSetup: 'icon-wrench',
      movement: 'icon-movement',
      'batt-full': 'icon-batt_3',
      'batt-half': 'icon-batt_2',
      'batt-low': 'icon-batt_1',
      'batt-empty': 'icon-batt_0',

      // Auraton
      AFS: 'auraton icon-fs',
      AFSV: 'auraton icon-fsv',
      AHC: 'auraton icon-rt',
      AHM: 'auraton icon-r03',
      AMHC: 'auraton icon-mhc',
      AR03: 'auraton icon-r03',
      ARC: 'auraton icon-trv',
      ART: 'auraton icon-rt',
      ARS: 'auraton icon-sw2',
      ASW1: 'auraton icon-sw1',
      ASW2: 'auraton icon-sw2',
      AT: 'auraton icon-at',
      ATRV: 'auraton icon-trv',

      // Honeywell
      BRD91: 'icon-brd91',
      CS92A: 'icon-cs92a',
      DT92E: 'icon-dt92e',
      EVO: 'icon-evo',
      HR91: 'icon-hr91',
      HR92: 'icon-hr92',
      T87RF: 'icon-t87rf'

    };
    return icons[key] ? icons[key] : 'lw_icon';
  }

  getProductCodeDisplay(productCode) {
    const productCodeObj = {
      // Smart Series
      LINK2: 'L2',
      linkplus: 'L2',
      L21EU: 'L21',
      L21MK2: 'L21',
      L22EU: 'L22',
      L22MK2: 'L22',
      L23EU: 'L23',
      L24EU: 'L24',
      L40TE: 'L40',
      L40TF: 'L40',
      L40TG: 'L40',
      L41EU: 'L41',
      L41TF: 'L41',
      L41TE: 'L41',
      L41TG: 'L41',
      L42MK2: 'L42',
      L42EU: 'L42',
      L92R: 'L92',
      L21MK3: 'LP21mk2',
      L22MK3: 'LP22mk2',
      L23MK3: 'LP23mk2',
      L24MK3: 'LP24mk2',
      L40MK2: 'LP40',
      L42MK3: 'LP42MK2',
      L51: 'LP51',
      L52: 'LP52',
      L53: 'LP53',
      L54: 'LP54',
      L70MK2: 'LP70',
      L71: 'LP71',
      L81: 'LP81',
      L82MK2: 'LP82',
      L92: 'LP92',
      L83: 'LP83'
    }
    return productCodeObj[productCode] ? productCodeObj[productCode] : productCode;
  }
}
